import React from 'react';

/**
 * Full-screen error fallback rendered by the ErrorBoundary.
 * Dark background so a white screen is never shown.
 * Touch anywhere to reload.
 */
const ErrorFallback: React.FC = () => {
  return (
    <button
      onClick={() => window.location.reload()}
      className="flex flex-col items-center justify-center h-screen w-screen bg-neutral-950 cursor-pointer focus:outline-none"
      style={{ WebkitTapHighlightColor: 'transparent', touchAction: 'manipulation' }}
      aria-label="Touch to restart the kiosk"
    >
      <div className="flex flex-col items-center gap-6 text-center px-8">
        <div className="flex items-center justify-center w-20 h-20 rounded-full bg-red-900/40 border border-red-800">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="w-10 h-10 text-red-400"
            aria-hidden="true"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </div>

        <div className="space-y-2">
          <h1 className="text-3xl font-bold text-white">Something went wrong</h1>
          <p className="text-lg text-neutral-400">
            An unexpected error occurred.
          </p>
        </div>

        <div className="mt-4 animate-pulse">
          <p className="text-base text-neutral-500 font-medium tracking-wide">
            Touch to restart
          </p>
        </div>
      </div>
    </button>
  );
};

export default ErrorFallback;
